import React, { useState } from "react";
import { Container, Typography, Tabs, Tab, Box, Paper } from "@mui/material";
import { layoutCSS } from "../component/common/commonStyle";

const codeSnippets = {
  phpGet: `<?php
$phno='0000000000';
$Msg="Your Text Msg";
$Password='XXXXXXXXX';
$SenderID='XXXXXX';
$UserID='XXXXXXX';
$EntityID='XXXXXXX';
$TemplateID='XXXXXXX';
function send_message($phno,$Msg,$Password,$SenderID,$UserID,$EntityID,$TemplateID) {         
    $url='http://sms.xcelmarketing.in/api/SmsApi/SendSingleApi?UserID='.$UserID.'&Password='.$Password.'&SenderID='.$SenderID.'&phno='.$phno.'&Msg='.urlencode($Msg).'&EntityID='.$EntityID.'&TemplateID='.$TemplateID;
    $ch = curl_init($url);
    curl_setopt($ch,CURLOPT_URL,$url);
    curl_setopt($ch,CURLOPT_RETURNTRANSFER,true);
    $output=curl_exec($ch);
    curl_close($ch);
    return $output;
}
echo send_message($phno,$Msg,$Password,$SenderID,$UserID,$EntityID,$TemplateID);
?>`,

  csharpGet: `public string HitGetAPI(string UserID, string Password, string SenderID, string PhoneNo, string Msg, string EntityID, string TemplateID) {
    string result = "";
    Msg = HttpUtility.UrlEncode(Msg);
    string testUrl = "http://sms.xcelmarketing.in/api/SmsApi/SendSingleApi?UserID=" + UserID + "&Password=" + Password + "&SenderID=" + SenderID + "&phno=" + PhoneNo + "&Msg=" + Msg + "&EntityID=" + EntityID + "&TemplateID=" + TemplateID;
    WebRequest reqObj = WebRequest.Create(testUrl);
    reqObj.Method = "POST";
    reqObj.ContentLength = 0;
    HttpWebResponse resObj = (HttpWebResponse)reqObj.GetResponse();
    using (Stream st = resObj.GetResponseStream()) {
        StreamReader str = new StreamReader(st);
        result = str.ReadToEnd();
        str.Close();
    }
    return result;
}`,

  javaGet: `import java.io.BufferedReader;
import java.io.InputStreamReader;
import java.net.URL;
import java.net.URLConnection;
import java.net.URLEncoder;

public class sendSMS {
    public String sendSms() {
        try {
            String username = "username=" + URLEncoder.encode("XXXXXXXX", "UTF-8");
            String password = "&password=" + URLEncoder.encode("XXXXXXXX", "UTF-8");
            String sender = "&sender=" + URLEncoder.encode("XXXXXX", "UTF-8");
            String sendto = "&sendto=" + URLEncoder.encode("XXXXXXXXXX", "UTF-8");
            String message = "&message=" + URLEncoder.encode("This is your message", "UTF-8");
            String entityid="xxxxxxxxx";
            String testUrl = "http://sms.xcelmarketing.in/api/SmsApi/SendSingleApi?UserID=" + username + "&Password=" + password + "&SenderID=" + sender + "&phno=" + sendto + "&Msg=" + message + "&EntityID=" + entityid;
            URL url = new URL(testUrl);
            URLConnection conn = url.openConnection();
            BufferedReader rd = new BufferedReader(new InputStreamReader(conn.getInputStream()));
            String line, sResult = "";
            while ((line = rd.readLine()) != null) {
                sResult = sResult + line + " ";
            }
            rd.close();
            return sResult;
        } catch (Exception e) {
            System.out.println("Error SMS " + e);
            return "Error " + e;
        }
    }
}`,

  jsGet: `// JavaScript (Frontend) Fetch API Example
const sendSMS = async () => {
    const UserID = "XXXXXXXX";
    const Password = "XXXXXXXX";
    const SenderID = "XXXXXX";
    const phno = "0000000000";
    const Msg = encodeURIComponent("Your Text Message");
    const EntityID = "XXXXXXX";
    const TemplateID = "XXXXXXX";

    const url = \`http://sms.xcelmarketing.in/api/SmsApi/SendSingleApi?UserID=\${UserID}&Password=\${Password}&SenderID=\${SenderID}&phno=\${phno}&Msg=\${Msg}&EntityID=\${EntityID}&TemplateID=\${TemplateID}\`;

    try {
        const response = await fetch(url);
        const data = await response.text();
        console.log("Response:", data);
    } catch (error) {
        console.error("Error sending SMS:", error);
    }
};
sendSMS();`,

  nodeGet: `// Node.js using Axios
const axios = require('axios');

const sendSMS = async () => {
    const params = {
        UserID: "XXXXXXXX",
        Password: "XXXXXXXX",
        SenderID: "XXXXXX",
        phno: "0000000000",
        Msg: "Your Text Message",
        EntityID: "XXXXXXX",
        TemplateID: "XXXXXXX"
    };

    try {
        const response = await axios.get("http://sms.xcelmarketing.in/api/SmsApi/SendSingleApi", { params });
        console.log("Response:", response.data);
    } catch (error) {
        console.error("Error sending SMS:", error);
    }
};

sendSMS();`,
};

const SampleCodeTabs = () => {
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (event, newIndex) => {
    setTabIndex(newIndex);
  };

  return (
    <Box sx={layoutCSS}>
      {/* Tabs */}
      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
      >
        <Tab label="PHP" />
        <Tab label="C#" />
        <Tab label="Java" />
        <Tab label="JavaScript" />
        <Tab label="Node.js" />
      </Tabs>

      {/* Tab Panels */}
      <Box sx={{ mt: 2 }}>
        {tabIndex === 0 && (
          <Box>
            <Typography variant="h6">GET API - PHP</Typography>
            <pre
              style={{
                background: "#f4f4f4",
                padding: "10px",
                overflow: "auto",
              }}
            >
              <code>{codeSnippets.phpGet}</code>
            </pre>
          </Box>
        )}
        {tabIndex === 1 && (
          <Box>
            <Typography variant="h6">GET API - C#</Typography>
            <pre
              style={{
                background: "#f4f4f4",
                padding: "10px",
                overflow: "auto",
              }}
            >
              <code>{codeSnippets.csharpGet}</code>
            </pre>
          </Box>
        )}
        {tabIndex === 2 && (
          <Box>
            <Typography variant="h6">GET API - Java</Typography>
            <pre
              style={{
                background: "#f4f4f4",
                padding: "10px",
                overflow: "auto",
              }}
            >
              <code>{codeSnippets.javaGet}</code>
            </pre>
          </Box>
        )}
        {tabIndex === 3 && (
          <Box>
            <Typography variant="h6">GET API - JavaScript</Typography>
            <pre
              style={{
                background: "#f4f4f4",
                padding: "10px",
                overflow: "auto",
              }}
            >
              <code>{codeSnippets.jsGet}</code>
            </pre>
          </Box>
        )}
        {tabIndex === 4 && (
          <Box>
            <Typography variant="h6">GET API - Node.js</Typography>
            <pre
              style={{
                background: "#f4f4f4",
                padding: "10px",
                overflow: "auto",
              }}
            >
              <code>{codeSnippets.nodeGet}</code>
            </pre>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default SampleCodeTabs;
